import React from 'react';
import type DetailsSettingsType from '@atlassian/jira-spa-apps-project-settings-details/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyDetailsSettings = lazyForPaint<typeof DetailsSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-details", jiraSpaEntry: "async-project-settings-details" */ '@atlassian/jira-spa-apps-project-settings-details'
		),
	),
);

const AsyncDetailsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDetailsSettings}
		pageId="project-settings-details"
		shouldShowSpinner={false}
	/>
);

export default AsyncDetailsSettings;
